module.exports = __webpack_public_path__ + "img/30.4a385f2b.jpg";